import React from "react"
import { BodyTextRegular, BodyTextSemibold } from "../typography/text"
import { css, useTheme } from "@emotion/react"

type Props = {
  onClick?: () => void
  children: React.ReactNode
  color?: string
  hoverColor?: string
  bold?: boolean
}

export const SelectorText = ({
  onClick,
  children,
  color,
  hoverColor,
  bold,
}: Props) => {
  const theme = useTheme()
  const selectorStyle = css`
    color: ${color ?? theme.colors.primary};
    cursor: pointer;
    &:hover {
      color: ${hoverColor ?? theme.colors.ctaMain};
    }
  `

  if (bold) {
    return (
      <BodyTextSemibold onClick={onClick} css={selectorStyle}>
        {children}
      </BodyTextSemibold>
    )
  }

  return (
    <BodyTextRegular onClick={onClick} css={selectorStyle}>
      {children}
    </BodyTextRegular>
  )
}
